function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_26830_9144)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.7422 0H2.25781C1.28855 0 0.5 0.788555 0.5 1.75781V14.8443C0.5 15.8136 1.28855 16.6021 2.25781 16.6021H8.15625V18.8281H7.17969C6.85609 18.8281 6.59375 19.0905 6.59375 19.4141C6.59375 19.7377 6.85609 20 7.17969 20H13.8203C14.1439 20 14.4062 19.7377 14.4062 19.4141C14.4062 19.0905 14.1439 18.8281 13.8203 18.8281H12.8438V16.6021H18.7422C19.7115 16.6021 20.5 15.8136 20.5 14.8443V1.75781C20.5 0.788555 19.7115 0 18.7422 0ZM2.25781 1.17188H18.7422C19.0653 1.17188 19.3281 1.43473 19.3281 1.75781V13.0864H1.67188V1.75781C1.67188 1.43473 1.93473 1.17188 2.25781 1.17188ZM11.6719 18.8281H9.32812V16.6021H11.6719V18.8281ZM18.7422 15.4303H2.25781C1.93473 15.4303 1.67188 15.1674 1.67188 14.8443V14.2583H19.3281V14.8443C19.3281 15.1674 19.0653 15.4303 18.7422 15.4303Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6246 10.7426H9.37524C9.05161 10.7426 8.78931 11.0049 8.78931 11.3285C8.78931 11.6521 9.05161 11.9144 9.37524 11.9144H11.6246C11.9482 11.9144 12.2105 11.6521 12.2105 11.3285C12.2105 11.0049 11.9482 10.7426 11.6246 10.7426Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.59375 9.41398H14.4064C14.73 9.41398 14.9923 9.15164 14.9923 8.82804V2.77332C14.9923 2.44972 14.73 2.18738 14.4064 2.18738H6.59375C6.27016 2.18738 6.00781 2.44972 6.00781 2.77332V8.82804C6.00781 9.15164 6.27016 9.41398 6.59375 9.41398ZM8.06125 8.2421L9.78047 6.60882L10.0965 6.9091C10.3227 7.12394 10.6775 7.12394 10.9036 6.9091L11.2197 6.60882L12.9389 8.2421H8.06125ZM13.8205 7.46324L12.0704 5.80066L13.8205 4.13812V7.46324ZM12.9389 3.35925L10.5001 5.67613L8.06125 3.35925H12.9389ZM7.17969 4.13812L8.92977 5.80066L7.17969 7.4632V4.13812Z",
  fill: "#23335B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_26830_9144"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0.5)"
})));

var SvgPatientInvitation = function SvgPatientInvitation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPatientInvitation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/patientInvitation.eee1ae17.svg";
export { ForwardRef as ReactComponent };